import axios from 'axios';

import { APIError } from '~/services/Errors';

export type WebrtcMetrics = {
  callId: string;
  snapshotTimestamp: number;
  jitterBufferMillis: number;
  roundTripTimeMillis: number;
  packetsLost: number;
  packetsCount: number;
  streamType?: string;
};

export type TimezoneEntry = {
  value: string;
  label: string;
};

/** Fetches the timezone list (fetchTimezones in App.svelte) */
export const fetchTimezones = async (): Promise<TimezoneEntry[]> => {
  try {
    const resp = await axios.get('/api/timezones/');
    return resp.data.map((v: string) => ({ value: v, label: v }));
  } catch (e) {
    console.error('unable to fetch timezone list', e);
    return [];
  }
};

export const postWebrtcMetrics = async (metrics: WebrtcMetrics): Promise<void> => {
  const path = '/api/webrtc-metrics/';

  const body = {
    contact_id: metrics.callId,
    snapshot_timestamp: new Date(metrics.snapshotTimestamp).toISOString(),
    jitter_buffer_milliseconds: metrics.jitterBufferMillis,
    round_trip_time_milliseconds: metrics.roundTripTimeMillis,
    packets_lost: metrics.packetsLost,
    packets_count: metrics.packetsCount,
    stream_type: metrics.streamType,
    dialler_type: 'sip',
  };

  try {
    await axios.request({
      method: 'POST',
      url: path,
      data: body,
      headers: {
        Accept: 'application/json',
      },
    });
  } catch (e) {
    if (axios.isAxiosError(e)) {
      throw new APIError(e.response?.status ?? 0, e.message);
    }

    throw new APIError(-1, e as string);
  }
};
